import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import mapStatus from './mapStatus';
import Status from './Status';

export interface Result {
	items: Status[];
}

export default function findStatuses(client: ApiClient): Promise<Result> {
	return client
		.fetch(parseTemplate('datasources-statuses').expand({}))
		.then((response) => response.json())
		.then((response) => ({
			items: response.items.map(mapStatus),
		}));
}
